import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, FileText } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { Btn, Eyebrow, Section, SectionTitle, Lead } from "@/components/ui-kit/Kit";
import { Reveal, Stagger, StaggerItem } from "@/components/motion/Reveal";

export const ResourcePreview = () => {
  const { t } = useI18n();
  const cats = (t("pages.resources.categories") || []).slice(0, 6);

  return (
    <Section className="py-24 sm:py-32" data-testid="resource-preview-section">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <Reveal>
          <Eyebrow>{t("home.resourcePreview.eyebrow")}</Eyebrow>
          <SectionTitle className="mt-6 max-w-[20ch]">{t("home.resourcePreview.title")}</SectionTitle>
          <Lead className="mt-5 max-w-xl">{t("home.resourcePreview.sub")}</Lead>
        </Reveal>
        <Reveal delay={0.1}>
          <Btn to="/resources" variant="outline" data-testid="view-knowledge-center">
            {t("nav.knowledge")} <ArrowRight className="h-4 w-4" />
          </Btn>
        </Reveal>
      </div>
      <Stagger className="mt-14 grid gap-px border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:grid-cols-3" step={0.05}>
        {cats.map((c, i) => (
          <StaggerItem key={c.key} className="bg-white">
            <Link to="/resources" className="group flex h-full flex-col p-8" data-testid={`resource-cat-${c.key}`}>
              <FileText className="h-6 w-6 text-navy/30 transition-colors duration-400 group-hover:text-grn" strokeWidth={1.4} />
              <h3 className="mt-8 font-display text-lg font-semibold text-navy group-hover:text-grn">{c.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{c.body}</p>
              <span className="mt-6 font-mono text-[10px] tracking-[0.2em] text-navy/25">
                {String(i + 1).padStart(2, "0")}
              </span>
            </Link>
          </StaggerItem>
        ))}
      </Stagger>
    </Section>
  );
};
